import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from '../_service/auth.service';
import { AuthConfigService } from '../_service/auth-config.service';
import { HttpService } from '../_service/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sds-view',
  templateUrl: './sds-view.component.html',
  styleUrls: ['./sds-view.component.css']
})
export class SdsViewComponent implements OnInit, OnDestroy {
  pdfUrl: SafeResourceUrl;
  loading = true;

  private objectUrl: string;
  private jwtHelper = new JwtHelperService();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private authConfigService: AuthConfigService,
    private httpService: HttpService
  ) {}

  ngOnInit() {
    const guid = this.route.snapshot.paramMap.get('id');
    if (!guid) {
      this.redirectWithMessage('Invalid SDS link.');
      return;
    }

    if (this.authService.loggedIn()) {
      this.fetchPdf(guid);
    } else if (this.authConfigService.isWindowsAuthMode()) {
      this.authenticateAndFetch(guid);
    } else {
      this.redirectWithMessage('Please log in to view this document.');
    }
  }

  ngOnDestroy() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }

  private authenticateAndFetch(guid: string) {
    this.httpService.HttpGetWithCredentials<any>(environment.apiWindowsAuthUrl)
      .subscribe(
        (response: any) => {
          localStorage.setItem('token', response.body.token);
          this.authService.decodedToken = this.jwtHelper.decodeToken(response.body.token);
          this.fetchPdf(guid);
        },
        () => {
          this.redirectWithMessage('Authentication failed. Please log in to view this document.');
        }
      );
  }

  private fetchPdf(guid: string) {
    const apiBase = environment.apiUrl.replace(/api\/$/, '');
    const url = `${apiBase}view/${guid}`;

    this.http.get(url, { responseType: 'blob' }).subscribe(
      (blob: Blob) => {
        this.objectUrl = URL.createObjectURL(blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
        this.loading = false;
      },
      (error) => {
        if (error.status === 404) {
          this.redirectWithMessage('SDS document not found.');
        } else if (error.status === 401) {
          this.redirectWithMessage('Authentication required. Please log in to view this document.');
        } else {
          this.redirectWithMessage('Unable to load the SDS document.');
        }
      }
    );
  }

  private redirectWithMessage(message: string) {
    sessionStorage.setItem('auth_message', message);
    this.router.navigate(['/search']);
  }
}
